export default __webpack_public_path__ + "static/media/icon-coin-om.cc9fede5.svg";